import cornerstoneTools from 'cornerstone-tools';
import { assertSameFrameOfReference } from './suvGating';


/**
 * CT-PET pairs with an RT structure set. A pair with mismatched FoR is still
 * returned (forOk: false) so its ROIs are marked NE with a reason, not dropped.
 */
export function discoverCTPETPairs(imageSets) {
  const pairs = [];
  for (const ctSet of imageSets) {
    if (!ctSet) continue;
    const structureSetUID = ctSet.rtstructSeriesInstanceUID;
    if (!structureSetUID) continue;
    if (!ctSet.isFusion || !ctSet.referencedDisplaySet) continue;
    const ctImages = ctSet.images;
    const petImages = ctSet.referencedDisplaySet.images;
    if (!ctImages?.length || !petImages?.length) continue;
    const ctImageIds = ctImages.map((img) => img.getImageId());
    const petImageIds = petImages.map((img) => img.getImageId());
    const { ok, ctFoR, petFoR } = assertSameFrameOfReference(ctImageIds[0], petImageIds[0]);
    pairs.push({
      structureSetUID,
      ctSeriesUID: ctSet.SeriesInstanceUID,
      petSeriesUID: ctSet.referencedDisplaySet.SeriesInstanceUID,
      ctImageIds,
      petImageIds,
      frameofRefOk: ok,
      ctFoR,
      petFoR,
    });
  }
  return pairs;
}

/**
 * Return [{ ctImageId, points: [{x, y}, ...] }] for one ROI, one polygon per
 * contour instance. Coordinates are CT-slice pixel coordinates.
 */
export function extractContoursByCtSlice(structureSetUID, roiNumber, ctImageIds) {

  const editModule = cornerstoneTools.getModule('rtstruct-edit');
  const out = [];
  for (const ctImageId of ctImageIds) {
    const toolState = editModule.getters.toolState(ctImageId); // = peekPainter().getState()
    const data = toolState?.data;
    if (!Array.isArray(data)) continue;
    const matches = data.filter(
      (d) =>
        d.structureSetSeriesInstanceUid === structureSetUID &&
        d.ROINumber === roiNumber
    );
    for (const m of matches) {
      const pts = m.handles?.points;
      if (!pts || pts.length < 3) continue;
      const points = pts
        .map((p) => (p && p.x != null && p.y != null ? { x: p.x, y: p.y } : null))
        .filter(Boolean);
      if (points.length >= 3) out.push({ ctImageId, points });
    }
  }
  const totalPts = out.reduce((n, o) => n + o.points.length, 0);

  return out;
}